import React from 'react';
import styled from 'styled-components';

import { getInstoreOrderDateAndTime } from 'shared/helpers/orders';
import type { PosOrderFieldsFragment } from 'src/gql/graphql';
import OrderReceiptSectionHeader from '../order-receipt/order-receipt-section-header';

type InstoreReceiptDetailsProps = {
  posOrder: PosOrderFieldsFragment;
};

export function InstoreReceiptDetails({ posOrder }: InstoreReceiptDetailsProps): JSX.Element {
  const { id, shipmentDeliveredLocal } = posOrder;

  const formattedDate = getInstoreOrderDateAndTime(shipmentDeliveredLocal);

  return (
    <Details>
      <OrderReceiptSectionHeader>
        <span>Details</span>
        <OrderNumber>
          <OrderNumberLabel>Order #:</OrderNumberLabel> {id}
        </OrderNumber>
      </OrderReceiptSectionHeader>

      <DetailsTableContainer>
        <DetailsTable>
          <tbody>
            {formattedDate && (
              <tr>
                <FieldLabel>Date:</FieldLabel>
                <FieldValue>{formattedDate}</FieldValue>
              </tr>
            )}
          </tbody>
        </DetailsTable>
      </DetailsTableContainer>
    </Details>
  );
}

const Details = styled.div`
  color: ${({ theme }) => theme.colors.primaryBlack};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[90]};
  width: 100%;
`;

const DetailsTableContainer = styled.div`
  padding: 8px 25px 17px;
`;

const OrderNumber = styled.div`
  color: ${({ theme }) => theme.colors.grey[35]};
  font-size: 13px;
  font-weight: normal;
`;

const OrderNumberLabel = styled.span`
  color: ${({ theme }) => theme.colors.grey[45]};
  text-transform: uppercase;
  font-weight: bold;
`;

const DetailsTable = styled.table`
  text-align: left;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey[30]};
  border-collapse: collapse;
  width: 100%;
`;

const FieldLabel = styled.td`
  font-weight: bold;
  text-transform: capitalize;
  white-space: nowrap;
  padding: 8px 16px 8px 0;
`;

const FieldValue = styled.td`
  text-transform: capitalize;
  text-align: right;
  width: 100%;
  padding: 8px 0;
`;
